import React, { useEffect, useState, useContext } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import AppLink from "./AppLink";
import AuthContext from "../Context/auth/AuthContext";

const CardCarousel = ({ cardArray, user }) => {
  const authContext = useContext(AuthContext);
  const { search } = authContext;
  const [cardData, setCardData] = useState(cardArray);
  const [itemsInCarousel, setItemsInCarousel] = useState();
  // console.log("USER CAROUSEL", user, cardArray);

  useEffect(() => {
    carouselItems();
  }, []);

  const carouselItems = () => {
    if (cardData.length > 4) {
      setItemsInCarousel(4);
    } else if (cardData.length > 2) {
      setItemsInCarousel(cardData.length);
    } else {
      setItemsInCarousel(cardData.length);
    }
    // console.log("itemsInCarousel", itemsInCarousel);
  };

  useEffect(() => {
    carouselItems();
  }, [cardData]);

  useEffect(() => {
    // console.log("SEARCH", search);
    if (cardArray && search) {
      const appsList = cardArray.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      // console.log("Filtered SEARCH", appsList);
      setCardData(appsList);
    } else {
      setCardData(cardArray);
    }
  }, [search]);

  return (
    <OwlCarousel
      margin={10}
      nav={true}
      navText={[
        "<i class='fa fa-chevron-left fa-2x'></i>",
        "<i class='fa fa-chevron-right fa-2x'></i>",
      ]}
      responsive={{
        0: {
          items: 1,
        },
        800: {
          items: 2,
        },
        1300: {
          items: itemsInCarousel,
        },
      }}
      className="owl-theme"
      dots
    >
      {cardData.map((ele) => (
        <div class="item" key={ele.name}>
          <AppLink cardDetails={ele} user={user} />
        </div>
      ))}
    </OwlCarousel>
  );
};

export default CardCarousel;
